const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.3247 81.9582C22.1364 81.9582 21.948 81.9015 21.786 81.78C16.5185 77.9058 12.1482 72.7963 9.1509 67.0042C6.05237 61.0178 4.41602 54.2658 4.41602 47.4774C4.41602 40.4237 6.1759 33.4368 9.50733 27.2762C9.7463 26.8327 10.2992 26.6686 10.7427 26.9076C11.1862 27.1466 11.3503 27.6994 11.1113 28.143C7.92364 34.0383 6.23868 40.7254 6.23868 47.4774C6.23868 60.3839 12.454 72.6585 22.8655 80.3137C23.2705 80.6115 23.3576 81.1825 23.0599 81.5876C22.8796 81.8306 22.6042 81.9582 22.3247 81.9582Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 22.951C13.8049 22.951 13.6084 22.8882 13.4424 22.7606C13.0434 22.4528 12.9705 21.8797 13.2783 21.4827C17.1707 16.4441 22.2256 12.2762 27.8981 9.42679C33.8481 6.43964 40.2639 4.9248 46.9693 4.9248C57.2633 4.9248 67.2009 8.65115 74.9472 15.4193C75.326 15.7494 75.3644 16.3266 75.0343 16.7053C74.7042 17.084 74.127 17.1245 73.7483 16.7924C66.3341 10.3158 56.8239 6.74747 46.9693 6.74747C34.2552 6.74747 22.501 12.5253 14.7203 22.5986C14.542 22.8295 14.2707 22.951 13.9993 22.951Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9691 90.0313C39.887 90.0313 32.8779 88.2572 26.699 84.8994C26.2575 84.6584 26.0935 84.1056 26.3325 83.6641C26.5735 83.2226 27.1263 83.0585 27.5678 83.2975C33.4814 86.5095 40.1888 88.2066 46.9671 88.2066C69.4264 88.2066 87.6976 69.9353 87.6976 47.476C87.6976 37.5445 84.0826 27.9796 77.519 20.5431C77.1869 20.1664 77.2213 19.5892 77.6 19.2571C77.9767 18.925 78.5539 18.9594 78.886 19.3381C85.7433 27.1088 89.5203 37.101 89.5203 47.4781C89.5223 70.9419 70.4329 90.0313 46.9691 90.0313Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1077 67.2135C30.9011 67.2135 30.6925 67.1426 30.5204 66.9988C24.7486 62.1343 21.4395 55.0199 21.4395 47.4781C21.4395 43.6525 22.2657 39.9707 23.898 36.536C24.1147 36.0803 24.6575 35.8879 25.1131 36.1046C25.5688 36.3213 25.7612 36.8641 25.5445 37.3197C24.0297 40.5074 23.2621 43.9259 23.2621 47.4801C23.2621 54.4832 26.3364 61.0914 31.695 65.6075C32.0798 65.9316 32.1284 66.5067 31.8044 66.8915C31.6241 67.1041 31.3669 67.2135 31.1077 67.2135Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5747 33.2245C27.3783 33.2245 27.1798 33.1617 27.0138 33.0301C26.6168 32.7202 26.548 32.1471 26.8578 31.7501C31.7365 25.5207 39.0656 21.9482 46.9699 21.9482C52.7336 21.9482 58.1773 23.8256 62.7076 27.3778C63.1046 27.6876 63.1734 28.2607 62.8636 28.6577C62.5537 29.0546 61.9806 29.1235 61.5837 28.8136C57.3753 25.5166 52.3225 23.7729 46.9699 23.7729C39.6307 23.7729 32.822 27.0902 28.2937 32.8761C28.1134 33.105 27.8461 33.2245 27.5747 33.2245Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.97 73.0056C42.9338 73.0056 39.0718 72.0902 35.4912 70.2858C35.0417 70.0589 34.8614 69.5101 35.0882 69.0626C35.3151 68.613 35.8639 68.4327 36.3114 68.6595C39.6368 70.3364 43.2234 71.185 46.97 71.185C60.0405 71.185 70.6768 60.5507 70.6768 47.4781C70.6768 41.7651 68.6172 36.2465 64.8747 31.9409C64.5446 31.5602 64.5851 30.985 64.9658 30.6549C65.3465 30.3248 65.9217 30.3653 66.2518 30.7461C70.2799 35.3837 72.4995 41.3256 72.4995 47.4781C72.4995 61.5552 61.0471 73.0056 46.97 73.0056Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1457 29.0061C61.9088 29.0061 61.6739 28.915 61.4957 28.7327C61.1433 28.3743 61.1473 27.7971 61.5078 27.4447L73.7096 15.4556C74.068 15.1032 74.6452 15.1073 74.9976 15.4678C75.3499 15.8262 75.3459 16.4034 74.9854 16.7558L62.7817 28.7449C62.6055 28.9191 62.3766 29.0061 62.1457 29.0061Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5631 32.255C65.314 32.255 65.0649 32.1538 64.8867 31.9533C64.5505 31.5786 64.5789 31.0035 64.9535 30.6653L77.5968 19.2635C77.9714 18.9253 78.5466 18.9556 78.8848 19.3303C79.2209 19.705 79.1926 20.2801 78.8179 20.6183L66.1747 32.0201C65.9985 32.1781 65.7798 32.255 65.5631 32.255Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5745 33.2248C27.3821 33.2248 27.1897 33.1641 27.0257 33.0405L13.4508 22.7667C13.0499 22.463 12.9709 21.8919 13.2747 21.4909C13.5784 21.0899 14.1495 21.0109 14.5505 21.3147L28.1253 31.5885C28.5263 31.8922 28.6053 32.4633 28.3015 32.8643C28.1233 33.1013 27.8499 33.2248 27.5745 33.2248Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 37.8388C24.5526 37.8388 24.3825 37.7922 24.2306 37.695L9.81733 28.4784C9.39406 28.207 9.2685 27.644 9.53988 27.2187C9.81125 26.7954 10.3743 26.6699 10.7995 26.9412L25.2128 36.1599C25.636 36.4313 25.7616 36.9943 25.4902 37.4195C25.3161 37.6909 25.0224 37.8388 24.7207 37.8388Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3241 81.9583C22.1661 81.9583 22.0041 81.9158 21.8583 81.8307C21.4269 81.5735 21.2851 81.0146 21.5423 80.5812L30.3256 65.8358C30.5828 65.4045 31.1417 65.2627 31.5751 65.5199C32.0065 65.7771 32.1482 66.336 31.891 66.7694L23.1078 81.5128C22.9357 81.8004 22.6339 81.9583 22.3241 81.9583Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1312 85.0113C26.9713 85.0113 26.8113 84.9688 26.6634 84.8817C26.2321 84.6225 26.0923 84.0635 26.3495 83.6322L35.1145 69.0043C35.3738 68.5729 35.9327 68.4331 36.3641 68.6903C36.7954 68.9496 36.9352 69.5085 36.678 69.9399L27.913 84.5678C27.7449 84.8534 27.4411 85.0113 27.1312 85.0113Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9297 68.868C44.8345 68.868 44.7373 68.8518 44.6421 68.8215C44.2269 68.6838 43.9697 68.2726 44.0244 67.8393L46.1509 51.4474H36.6831C36.3692 51.4474 36.0796 51.2874 35.9115 51.0221C35.7455 50.7568 35.7252 50.4247 35.8609 50.1432L47.3538 26.1873C47.5422 25.7944 47.9816 25.5898 48.4029 25.6992C48.8241 25.8086 49.1096 26.1994 49.0853 26.6348L48.1457 42.8464L57.8301 44.3167C58.1258 44.3613 58.3809 44.5496 58.5126 44.8169C58.6442 45.0863 58.6341 45.4022 58.4883 45.6635L45.7215 68.4023C45.5595 68.6959 45.2517 68.868 44.9297 68.868ZM38.1331 49.6247H47.1898C47.451 49.6247 47.7021 49.7381 47.8743 49.9346C48.0464 50.131 48.1274 50.3943 48.093 50.6535L46.4384 63.4061L56.2545 45.9207L47.0521 44.5233C46.5863 44.4524 46.2521 44.0393 46.2784 43.5694L46.9994 31.1409L38.1331 49.6247Z",
    fill: "#231F20",
    stroke: "black",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.16054
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon-energy.57f3f0884df8574f4f94c0ac3d1a9e2a.svg";
export { ForwardRef as ReactComponent };